/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

// @ts-ignore
export const customStyles = {
  option: () => ({
    borderBottom: '1px solid #F3F4F7',
    fontSize: '14px',
  }),
  dropdownIndicator: (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    base: any,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    state: { selectProps: { menuIsOpen: any } }
  ) => ({
    ...base,
    display: !state.selectProps.menuIsOpen && 'none',
    position: state.selectProps.menuIsOpen ? 'absolute !important' : null,
  }),

  multiValueRemove: (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    base: any,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    state: { selectProps: { isFocused: any } }
  ) => ({
    ...base,
    ':hover': {
      color: '#1cb954',
      fontWeight: '400',
      backgroundColor: state.selectProps.isFocused && '#DDF5E5;',
    },
  }),
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  singleValue: (base: any, state: { isDisabled: any }) => {
    const opacity = state.isDisabled ? 0.5 : 1
    const transition = 'opacity 500ms'

    return { ...base, opacity, transition }
  },
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  menuList: (base: any) => ({
    ...base,

    '::-webkit-scrollbar': {
      width: '4px',
      paddingTop: '14px',
    },
    '::-webkit-scrollbar-track': {
      background: '#F9F9F9',
      borderRadius: '7px',
      paddingTop: '40px',
    },
    '::-webkit-scrollbar-thumb': {
      background: '#CCCCCC',
      height: '49px',
      borderRadius: '4px',
    },
    '::-webkit-scrollbar-thumb:hover': {
      background: '#CCCCCC',
    },
  }),
}

export const mobileCustomStyles = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  menu: (base: any) => ({ ...base, opacity: 0 }),
}
